import {Injectable} from '@angular/core';
import {ServerService} from '../services/server.service';
import {User} from "./User";
import {DataService} from "../services/data.service";
import {Esercizio, EsercizioData} from "./Esercizio";
import _ from "lodash";
import {PVenditaUtente} from "./PVenditaUtente";
import {id} from "@swimlane/ngx-charts";

export class EsercizioUtenteData{
   public id?:number;
   public esercizio?: EsercizioData
   public user?
   public pvendita_utenti?
   public amministratore?:any
   public esercizio_role?

   public is_proprietario? : boolean
   public is_amministrativo? : boolean
   public is_gestoreweb? : boolean
}

export class EsercizioUtente {

   public data: EsercizioUtenteData = {}
   public pVenditaUtenti = {}

   ID!: number;
   esercizio!:Esercizio

   constructor(data:EsercizioUtenteData = {}) {
      if(!data) data = {}

      Object.assign(this.data, data);

      if(data.esercizio && !_.isNumber(data.esercizio)){
         this.esercizio = new Esercizio(data.esercizio)
      }

      if (this.data.id != null) {
         this.ID = this.data.id;
      }
      if(this.data.pvendita_utenti){
         for (let i = 0; i < this.data.pvendita_utenti; i++) {
            this.pVenditaUtenti[this.data.pvendita_utenti.id] = new PVenditaUtente(this.data.pvendita_utenti[i])
         }
      }
   }

}


@Injectable({
   providedIn: 'root'
})
export class EsercizioUtenteFactory {

   constructor(private serverSrv:ServerService,
               private dataSrv:DataService) {
   }

   async getUtentiEsercizio(esercizio_id:number):Promise<EsercizioUtente[]>{
      let url = `/api/esercizi/${esercizio_id}/utenti`
      return new Promise<EsercizioUtente[]>((resolve, reject) => {
         this.serverSrv.getAll(EsercizioUtente, url).then(res => {
            resolve(res)
         }).catch(err =>{reject(err)})
      })

   }

   async getEserciziUtente(user_id: number | undefined): Promise<EsercizioUtente[]> {
      let url = `/api/utenti/${user_id}/esercizi_utente`
      return new Promise<EsercizioUtente[]>((resolve, reject) => {
         this.serverSrv.getAll(EsercizioUtente, url)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }

   getEsercizioUtente(user_id, esercizio_utente_id: any): Promise<EsercizioUtente> {
      let url = `/api/utenti/${user_id}/esercizi_utente/${esercizio_utente_id}`
      return new Promise<EsercizioUtente>((resolve, reject) => {
         this.serverSrv.get(EsercizioUtente, url)
            .then(res=>{resolve(res)})
            .catch(err=>{reject(err)})
      })
   }

   uploadEsercizioUtente(user_id, esercizio_utente_id, files): Promise<boolean> {
      let url = `/api/utenti/${user_id}/esercizi_utente/${esercizio_utente_id}/esercizio/image`
      return new Promise<boolean>((resolve, reject) => {
         this.serverSrv.uploadFile(url, files)
            .then(res=>{resolve(true)})
            .catch(err=>{reject(err)})
      })
   }
}
